import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=1cf17642&scoped=true&"
import script from "./ProductSearch.vue?vue&type=script&lang=ts&"
export * from "./ProductSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSearch.vue?vue&type=style&index=0&id=1cf17642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf17642",
  null
  
)

export default component.exports